export const typeDefs = `
    type UserData {
        isLoggedIn: Boolean!
        accessToken: String
        userId: String
    }
`;

const pollMlbOkta = async({
    interval,
    maxAttempts,
}) => {

    let attempts = 0;

    const executePoll = async(resolve, reject) => {

        if (typeof window === 'undefined') {

            return reject(new Error('No window object'));

        }

        if (maxAttempts && attempts === maxAttempts) {

            return reject(new Error('Exceeded max attempts'));

        }

        attempts++;

        const { mlbOkta } = window;

        if (typeof mlbOkta === 'undefined' || typeof mlbOkta.isLoggedIn !== 'function') {

            return setTimeout(executePoll, interval, resolve, reject);

        }

        try {

            const result = await mlbOkta.isLoggedIn();
            return resolve(result);

        } catch (error) {

            return reject(error);

        }

    };

    return new Promise(executePoll);

};

const Query = {
    async userData() {

        if(typeof window === 'undefined') {

            return null;

        }

        const data = pollMlbOkta({
            interval: 200,
            maxAttempts: 50,
        })
            .then(({
                loggedIn,
                accessToken,
                idToken,
            }) => ({
                isLoggedIn: loggedIn,
                userId: idToken?.claims?.sub || '',
                accessToken: accessToken?.accessToken,
                __typename: 'UserData',
            }))
            .catch(() => ({
                isLoggedIn: false,
                userId: '',
                accessToken: '',
                __typename: 'UserData',
            }));

        return data;

    },
};

export const resolvers = {
    Query,
};
